import Quill from 'quill';

// Get Parchment from Quill
const Parchment = Quill.import('parchment') as any;

// Create the custom size attributor with an extended whitelist
const customSizeStyle = new Parchment.Attributor.Style('size', 'font-size', {
	scope: Parchment.Scope.INLINE,
	whitelist: [
		// Include Quill's default sizes
		'small', 'normal', 'large', 'huge',
		// Add common pixel sizes - generate all sizes from 8 to 200
		...Array.from({ length: 193 }, (_, i) => `${i + 8}px`)
	]
});

// Function to dynamically add a size to the whitelist if not present
function ensureSizeInWhitelist(size: string) {
	if (customSizeStyle.whitelist && !customSizeStyle.whitelist.includes(size)) {
		customSizeStyle.whitelist.push(size);
	}
}

// Export function to register the custom size format
export function registerCustomSizeFormat() {
	try {
		// Register our custom size style, overriding the default
		Quill.register(customSizeStyle, true);
		
		console.log('Custom font-size format registered successfully');
		return true;
	} catch (error) {
		console.error('Failed to register custom font-size format:', error);
		return false;
	}
}

// Export a function to apply font size that ensures the size is whitelisted
export function applyFontSize(quill: any, range: any, sizeValue: string) {
	// Ensure the size is in the whitelist
	ensureSizeInWhitelist(sizeValue);
	
	// Apply the format
	if (range.length === 0) {
		// If no selection, prepare format for next input
		quill.format('size', sizeValue);
	} else {
		// Apply to selected text
		quill.formatText(range.index, range.length, 'size', sizeValue);
	}
}

// Export the custom size style for direct use if needed
export { customSizeStyle };